<template>
  <Dialog v-model:visible="visible"
    :modal="true"
    position="top"
    :contentStyle="{'overflow': 'visible'}"
    ref="dialog"
    @show="onShow"
    @hide="onHide"
    class="lll">
    <template #header>
      <h2>Продукти</h2>
    </template>
    <Products @select="onSelect"/>
    <template #footer>
      <ButtonsApplyCancel @apply="onChoose" @cancel="$refs.dialog.close()" label-ok="Избор"/>
    </template>
  </Dialog>

</template>

<script>
export default {
  inheritAttrs: false,
  emits: {
    load: null,
    select: null
  },
  data() {
    return {
      visible: false,
      data: {}
    }
  },

  created() {
  },

  props: {
    title: String,
    selected: Object
  },

  methods: {
    onShow() {
      this.data = {}
      this.$emit('load', this.data);
    },
    onHide() {
      this.data = {};
    },
    onChoose() {
      this.$emit('select', this.data);
      this.$refs.dialog.close();
    },
    onSelect(data) {
      this.data = data.target;
      //console.log(data.target);
      //this.$emit('select', data.target);
      // console.log(data);
      // this.$refs.dialog.close();
    },
    open() {
      this.visible = true;
    }
  },

  computed: {
    net: function() {
      if (this.data.quantity && this.data.price) {
        return this.data.quantity *  this.data.price;
      }
      return 0;
    },
    vat: function() {
      if (this.data.vatP) {
        if (this.data.quantity && this.data.price) {
          return this.data.quantity *  this.data.price * (this.data.vatP / 100);
        }
      }
      return 0;
    },
    gros: function() {
      if (this.data.quantity && this.data.price) {
        return this.data.quantity *  this.data.price;
      }
      return 0;
    }
  }
}
</script>

<style>
</style>
